import { render, staticRenderFns } from "./MetaLinks.vue?vue&type=template&id=1852ceac&scoped=true"
import script from "./MetaLinks.vue?vue&type=script&lang=js"
export * from "./MetaLinks.vue?vue&type=script&lang=js"
import style0 from "./MetaLinks.vue?vue&type=style&index=0&id=1852ceac&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1852ceac",
  null
  
)

export default component.exports